import { render, staticRenderFns } from "./MonacoWithTree.vue?vue&type=template&id=18fd8d22&"
import script from "./MonacoWithTree.vue?vue&type=script&lang=js&"
export * from "./MonacoWithTree.vue?vue&type=script&lang=js&"
import style0 from "./MonacoWithTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports